<svg
  class="ideal"
  xmlns:dc="http://purl.org/dc/elements/1.1/"
  xmlns:cc="http://creativecommons.org/ns#"
  xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
  xmlns:svg="http://www.w3.org/2000/svg"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 781.92 164.16"
  version="1.1"
>
  <title>Ideal Supply Inc.</title>
  <path class="primary" d="M193.59,38.22h21.12l-11.15,70.39H182.44Z"></path>
  <path
    class="primary"
    d="M255,36.21h19.11l-11.46,72.4H224.08a10.38,10.38,0,0,1-10.41-12.37l4.44-28c1.08-6.74,7.59-12.37,14.32-12.37h19.43Zm-22,59.14H245.6l4.15-26.26H237.08Z"
  ></path>
  <path
    class="primary"
    d="M276.85,68.19c1.07-6.74,7.59-12.37,14.33-12.37h23.13a10.39,10.39,0,0,1,10.42,12.37L323.64,75c-1.06,6.73-7.59,12.36-14.33,12.36H292.92L292,93.33h29.78l-8.47,15.28H282.81a10.37,10.37,0,0,1-10.4-12.37Zm18.81,1.91-1,6.63h10.65l1.05-6.63Z"
  ></path>
  <path
    class="primary"
    d="M327.39,89.4C328.47,82.66,335,77,341.72,77h16.41l.93-5.93H330.29l8.46-15.28h29.47a10.39,10.39,0,0,1,10.42,12.37l-6.4,40.42H336.72a10.38,10.38,0,0,1-10.41-12.37Zm28,4.93,1-6.63H345.78l-1.06,6.63Z"
  ></path>
  <path
    class="primary"
    d="M392.64,108.61a10.38,10.38,0,0,1-10.4-12.37l9.5-60h19.12l-8.77,55.18h12l-8.73,17.22Z"
  ></path>
  <path
    class="primary"
    d="M412.53,108.61l8.77-17.3h30.57l1.67-10.45H432.2c-7.13,0-11.46-5.13-10.32-12.27l2.87-18.1A14.34,14.34,0,0,1,439,38.22h43.47l-8.78,17.3H445.08L443.42,66h21.32c7.14,0,11.46,5.13,10.34,12.27l-2.87,18.11A14.34,14.34,0,0,1,458,108.61Z"
  ></path>
  <path
    class="primary"
    d="M486.67,55.82h19.09l-5.92,37.51H512.5l6-37.51h19.11l-8.36,52.79H490.67a10.37,10.37,0,0,1-10.4-12.37Z"
  ></path>
  <path
    class="primary"
    d="M553.71,127.92H534.59L546,55.82h38.54A10.39,10.39,0,0,1,595,68.19l-4.44,28.05c-1.07,6.75-7.59,12.37-14.33,12.37H556.76Zm17.83-32.57,4.16-26.26H563l-4.15,26.26Z"
  ></path>
  <path
    class="primary"
    d="M612.44,127.92H593.33l11.42-72.1h38.52a10.39,10.39,0,0,1,10.42,12.37l-4.45,28.05c-1.06,6.75-7.58,12.37-14.32,12.37H615.5Zm17.83-32.57,4.16-26.26H621.75l-4.14,26.26Z"
  ></path>
  <path
    class="primary"
    d="M667.31,108.61a10.38,10.38,0,0,1-10.42-12.37l9.52-60h19.11l-9,57.12h8.65l-8.47,15.28Z"
  ></path>
  <path
    class="primary"
    d="M736.52,115.56c-1.08,6.74-7.6,12.36-14.35,12.36H682.25l7.88-14.28H717.7l1-6H699.25a10.4,10.4,0,0,1-10.42-12.38l6.24-39.42h19.11l-5.78,36.5h12.68l5.78-36.5H746Z"
  ></path>
  <path
    class="primary"
    d="M69.88,106.76a33.93,33.93,0,1,1,0-67.86h5.91V58.53H69.88a14.29,14.29,0,0,0,0,28.58h5.91v19.65Zm39.84,0a33.93,33.93,0,0,0,0-67.86h-5.91V58.53h5.91a14.29,14.29,0,1,1,0,28.58h-5.91v19.65ZM80.66,36.21H98.93V61.08H80.66V36.21Zm0,48.36H98.93v24.88H80.66V84.57Z"
  ></path>
</svg>
<div class="daltco">
  <svg
    viewBox="0 0 101 69"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
    class="link"
  >
    <path
      class="accent"
      d="m 31.504298,65.502457 a 31.504178,31.502458 0 1 1 0,-63.0049147 h 5.487467 V 20.723102 h -5.487467 a 13.268338,13.267614 0 0 0 0,26.535227 h 5.487467 v 18.244128 z m 36.991644,0 a 31.504178,31.502458 0 0 0 0,-63.0049147 H 63.008478 V 20.723102 h 5.487464 a 13.268338,13.267614 0 1 1 0,26.535227 H 63.008478 V 65.502457 Z M 41.513584,0 H 58.477372 V 23.090661 H 41.513584 Z m 0,44.900055 H 58.477372 V 68 H 41.513584 Z"
    />
  </svg>
  <svg
    viewBox="0 0 123 23"
    version="1.1"
    xml:space="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <title>Daltco Electric</title>
    <path
      d="m 110.23605,3.85e-5 c -8.38596,0 -11.565371,5.8572469 -11.565371,10.6407675 0,2.467869 0.484279,11.359193 11.625361,11.359193 C 118.05757,21.999999 122,17.190303 122,11.225294 122,6.0820841 119.14025,3.85e-5 110.23605,3.85e-5 Z m 0.14411,4.0757489 c 4.65427,0 6.18006,3.6163209 6.18006,6.6414806 0,5.159753 -2.54214,7.190835 -6.18006,7.190835 -5.64083,0 -6.34239,-4.696432 -6.34239,-7.22997 0,-2.5895537 1.61507,-6.6023456 6.34239,-6.6023456 z"
      class="accent"
    ></path>
    <path
      d="m 87.108891,3.85e-5 c -8.139822,-0.00496507 -11.598192,5.660203 -11.598192,10.6243525 0,5.097591 2.650093,11.30992 11.805842,11.30992 5.111636,0 10.075343,-2.817381 10.075343,-8.520413 l -5.036128,0.04925 c 0,0.845353 -0.995925,4.494205 -4.987927,4.494205 -4.549646,0 -6.442095,-3.348028 -6.434386,-7.272422 0.0079,-3.938693 2.59197,-6.6828094 6.210314,-6.6828094 2.621587,0 5.05511,2.068787 5.05511,3.6659815 h 5.181746 c 0,-4.5674203 -4.39627,-7.66450368 -10.271722,-7.6681083205836 z"
      class="accent"
    ></path>
    <path
      d="M 56.579682,0.49896875 V 4.424991 h 7.088165 v 16.948902 h 5.187748 V 4.424991 h 6.9372 V 0.49896875 h -7.113337 -4.961286 z"
      class="accent"
    ></path>
    <path
      d="M 44.472524,0.49896875 V 21.424765 H 60.955095 V 17.498753 H 49.618332 V 0.49896875 Z"
      class="accent"
    ></path>
    <path
      d="m 28.418043,0.49897294 -8.93864,21.00605506 5.383188,-8e-6 1.781006,-4.575116 8.678344,-4e-6 1.804576,4.575186 5.483353,-2e-6 -8.856122,-21.00604619 z m 2.671584,5.29445606 2.960907,7.453188 -6.017222,0.0831 z"
      class="accent"
    ></path>
    <path
      d="M -6.5695458e-7,0.49896875 V 21.517235 L 9.5993972,21.505616 C 21.334273,21.505616 20.800388,11.95367 20.80585,11.033334 20.844011,4.6040216 17.355328,0.53410161 9.3743443,0.50356641 v -0.001986 z M 9.3358891,4.5870211 c 4.2071749,0 6.1600649,2.5216315 6.1600649,6.3522749 0,2.708149 -0.457213,6.556994 -6.2092877,6.556994 H 5.2901861 V 4.6675149 c 0.3296649,0 4.045699,-0.080136 4.045699,-0.080136 z"
      class="accent"
    ></path>
  </svg>
</div>
<div class="parry">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 730.31 209.43"
    class="parry"
  >
    <path
      class="primary"
      d="M722.7,27.1A37.18,37.18,0,0,1,701,0a37.2,37.2,0,0,1-21.68,27.1c-2.19,1-7.61,2.43-7.61,2.43S677.15,31,679.34,32A37.24,37.24,0,0,1,701,59.07,37.22,37.22,0,0,1,722.7,32c2.18-.95,7.61-2.43,7.61-2.43S724.88,28.06,722.7,27.1Z"
    />
    <path
      class="accent"
      d="M114.51,119.15H63l-7.71,28.77H2.67L28,53H134.54c9,0,23.13,3.86,17.94,23.14l-5,18.69C142.4,113.66,127,119.15,114.51,119.15ZM100,76.73c1.78-6.68.75-8.16-4.44-8.16h-19l-9.2,34.26h18c5.19,0,8-1.48,9.79-8.16Z"
    />
    <path
      class="accent"
      d="M191.79,148.07l-.74-16.76H155l-10.23,16.76h-18.1L182.45,53H244l3.56,95.08Zm-1.34-77.13-25.06,43.31h25.36Z"
    />
    <path
      class="accent"
      d="M328.4,147.92l-7.42-31h-7.56l-8.31,31H252.45L277.82,53H383.73c9,0,23.43,4.9,18.54,23.14l-4.6,16.76a31.54,31.54,0,0,1-20.47,22l8.6,33.07Zm21.21-71c1.78-6.67-.45-8.3-5.64-8.3H326.32l-8.6,32.48h17.8c5,0,8.45-2.67,9.94-8.45Z"
    />
    <path
      class="accent"
      d="M468.42,147.92l-7.42-31h-7.56l-8.31,31H392.47L417.84,53h105.9c9,0,23.44,4.9,18.54,23.14l-4.59,16.76a31.54,31.54,0,0,1-20.47,22l8.6,33.07Zm21.21-71c1.78-6.67-.45-8.3-5.64-8.3H466.34l-8.6,32.48h17.8c5,0,8.45-2.67,9.94-8.45Z"
    />
    <path
      class="accent"
      d="M621.49,117.66l-8.16,30.26h-55l7.86-29.07L552.22,53h58.44l7.27,43.46L649.38,53h18.83Z"
    />
    <path
      class="primary"
      d="M6.56,209.43c-6.4,0-7.49-2.65-5.92-8.57l.42-1.63c1.27-4.65,4.11-8.57,10.51-8.57H35.41c.25-.85.25-.91.61-2.24s.06-1.81-1.93-1.81H10.66l1.45-5.55H34.87c7.19,0,8.76,3,6.7,10.68l-3.32,12.38c-.78,2.9-.9,3.2-1.45,5.31ZM34,196.15H11.32c-2.17,0-3.13.36-3.68,2.42l-.78,2.89c-.55,2.06.24,2.42,2.41,2.42H29.5c2,0,2.41-.18,3.14-2.78Z"
    />
    <path
      class="primary"
      d="M77.63,209.43c-6.7,0-8.39-4-6.7-10.32L74,187.58c1-3.93,1-3.75,1.75-6.52h6.4l-5.5,20.47c-.48,1.75,0,2.35,1.75,2.35H99.3c1.76,0,2.48-.6,3-2.35L106,187.58c1-3.93.9-3.32,1.75-6.52h6.4l-5.86,21.85c-1,3.93-1.21,4.41-1.75,6.52Z"
    />
    <path
      class="primary"
      d="M147.32,209.43c-4.53,0-8-1.81-6.1-8.87l6.88-25.66h6.4l-1.63,6.16h10.75l-1.51,5.55H151.36l-4,15c-.49,1.81-.31,2.29,2.23,2.29h8.69l-1.51,5.55Z"
    />
    <path
      class="primary"
      d="M218.26,209.43H196.05c-6.4,0-7.49-2.65-5.92-8.57l3-11.23c1.57-5.92,4.1-8.57,10.5-8.57h22.22c6.4,0,7.49,2.65,5.92,8.57l-3,11.23C227.2,206.78,224.66,209.43,218.26,209.43Zm7.31-20.52c.42-1.63.12-2.3-1.57-2.3H202.39c-1.57,0-2.24.67-2.66,2.3l-3.38,12.68c-.42,1.62-.12,2.29,1.45,2.29h21.61c1.69,0,2.36-.67,2.78-2.29Z"
    />
    <path
      class="primary"
      d="M306.3,209.43c.67-2.47.73-2.59,1.75-6.52l3.81-14.25c.48-1.68,0-2-1.21-2H297c-1.09,0-1.88.61-2.3,2l-3.8,14.25c-1,3.93-1,3.93-1.75,6.52h-6.4c.66-2.47.72-2.59,1.75-6.52l3.8-14.25c.42-1.44-.12-2-1.21-2H272.61c-1.08,0-1.87.61-2.29,2l-3.8,14.25c-1,3.93-1,3.75-1.75,6.52h-6.4c.66-2.47.72-2.59,1.75-6.52l4.1-15.33c1-3.93,1.15-4.35,1.75-6.52h47.4c4.46,0,6.4,2.17,5,7.48L315,201.1c-1,3.93-1.45,5.5-2.24,8.33Z"
    />
    <path
      class="primary"
      d="M374.6,209.43H352.39c-6.4,0-7.49-2.65-5.92-8.57l3-11.23c1.57-5.92,4.1-8.57,10.5-8.57h22.22c6.4,0,7.49,2.65,5.92,8.57l-3,11.23C383.54,206.78,381,209.43,374.6,209.43Zm7.31-20.52c.42-1.63.12-2.3-1.57-2.3H358.73c-1.57,0-2.24.67-2.66,2.3l-3.38,12.68c-.42,1.62-.12,2.29,1.45,2.29h21.61c1.69,0,2.36-.67,2.78-2.29Z"
    />
    <path
      class="primary"
      d="M423.1,209.43c-4.53,0-8-1.81-6.1-8.87l6.88-25.66h6.4l-1.63,6.16H439.4l-1.51,5.55H427.14l-4,15c-.49,1.81-.3,2.29,2.23,2.29h8.7l-1.51,5.55Z"
    />
    <path
      class="primary"
      d="M464.28,209.43l7.61-28.37h6.4l-7.61,28.37Zm8.82-32.36,1.63-6.28h6.16l-1.64,6.28Z"
    />
    <path
      class="primary"
      d="M525.09,209.43H517.6l-9.78-28.37h7.3l7.79,22.58,19.87-22.58h7.3Z"
    />
    <path
      class="primary"
      d="M579.5,198.33l-.67,2.65c-.6,2.05.18,2.9,2.48,2.9h22.94l-1.51,5.55H578.35c-6.4,0-7.49-2.59-5.92-8.57l3-11.23c1.57-5.92,3.75-8.57,10.51-8.57h21.67c6.76,0,7.61,2.35,5.92,8.57l-2.36,8.7Zm28.19-9.42c.43-1.63.12-2.3-1.45-2.3H584.69c-1.57,0-2.23.67-2.66,2.3l-1,3.86h25.66Z"
    />
  </svg>
</div>
